<template>
  <div class="content">
    <div class="security-box">
      <div class="security-title">網上平台管理系統</div>
      <div>
        <el-form
          label-position="top"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          :model="formLabelAlign"
        >
          <el-form-item label="帳戶名稱：" prop="userNo">
            <el-input v-model="formLabelAlign.userNo">
              <i slot="prefix" class="el-input__icon el-icon-user-solid"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="密碼：" prop="password">
            <el-input
              show-password
              v-model="formLabelAlign.password"
              prefix-icon="el-icon-lock"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <!--            跳过验证码-->
            <!--            <div id="grecaptcha" style="margin-top: 2rem;"></div>-->
          </el-form-item>
          <el-form-item class="login-box">
            <!--            有验证码控制的按钮-->
            <!--            <el-button-->
            <!--              type="info"-->
            <!--              :disabled="!recaptchaResult"-->
            <!--              @click="onLoginButtonClick"-->
            <!--              >登入</el-button-->
            <!--            >-->
            <el-button
                type="info"
                @click="onLoginButtonClick"
            >登入</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <loadingDialog :center-dialog-visible="centerDialogVisible"></loadingDialog>
  </div>
</template>

<script>
import { login,recaptcha } from "@/api/security";
import { setToken } from "@/utils/auth";
import loadingDialog from "@/components/loadingDialog/index";
import uuidv1 from "uuid/v1";
export default {
  components: { loadingDialog },
  data() {
    return {
      centerDialogVisible: false,
      recaptchaResult: false,
      formLabelAlign: {
        userNo: "",
        password: "",
      },
      rules: {
        userNo: [
          { required: true, message: "帳戶名稱不能為空", trigger: "blur" },
        ],
        password: [
          { required: true, message: "密碼不能為空", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    //想不验证
    // this.initial()
  },
  methods: {
    // initial(){
    //   let that =this
    //   window.onload = function() {
    //     window.grecaptcha.render("grecaptcha", {
    //       // sitekey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',//test 6LeIxAcTAAAAAGG-vFI1TnRWxMZNFuojJ4WifJWe
    //       sitekey: "6LdaEQIoAAAAAM7p77HXb8V3dZN1yZiVNedP_UjE",
    //       hl: "en",
    //       callback: that.submit,
    //     });
    //   }
    // },
    submit(token) {
      let from = {
        token:token
      }
      recaptcha(from).then(()=>{
        this.recaptchaResult = true
      })
    },
    onLoginButtonClick() {
//跳过验证登录
      this.login();
      // 表單驗證
      // this.$refs.ruleForm.validate((valid) => {
      //   if (valid) {
      //     if(this.recaptchaResult){
      //       this.login();
      //     }else {
      //       this.$message({
      //         message: "請完成驗證碼",
      //         type: "warning",
      //       });
      //     }
      //   }
      // });
    },
    login() {
      this.centerDialogVisible = true;
      let form = {
        userNo: this.formLabelAlign.userNo.trim(),
        password: this.formLabelAlign.password.trim(),
        deviceId: uuidv1(),
      };
      login(form)
        .then((v) => {
          this.$store.dispatch("setAdminUserInfo", v.data);
          setToken(v.data.accessToken);
          if(this.$store.getters.adminUserInfo.roleId == 2){
            this.$router.push({ path: "/studentJob" });
          }else if(this.$store.getters.adminUserInfo.roleId == 3){
            this.$router.push({ path: "/evaluate" });
          }else{
            this.$router.push({ path: "/" });
          }
        })
        .finally(() => {
          this.centerDialogVisible = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 100% !important;
  background-color: #f3f3f3;
  .image-box {
    padding-top: 50px;
    padding-bottom: 100px;
  }
}
.security-box {
  width: 700px;
  height: 665px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  justify-items: center;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.el-form {
  width: 600px;
  display: block;
}
.el-form-item {
  color: #fff !important;
}
.security-title {
  font-size: 36px;
  color: #b62d2e;
  margin-bottom: 40px;
}
.el-button--info {
  width: 100%;
}
.loginButtonResult{
    color: #FFF;
    background-color: #c8c9cc;
    border-color: #c8c9cc;
}
::v-deep {
  .el-form--label-top .el-form-item__label {
    color: #707070 !important;
    font-size: 20px;
  }

  .el-input__inner {
    border-radius: 0;
  }
}

.logo-img {
  user-select: none;
  display: block;
  width: 368px;
}
</style>